import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledTypo = styled(Typography)`
  font-weight: 500;
  padding-bottom: 2rem;
  padding-top: 5.5rem;
`;
